import { accessToken } from 'ccs-ui-components';
import CipAiPlatformApp from '../cip-ai-platform/CipAiPlatformApp';
import classes from './AiAssistPage.module.scss';

const CIP_AI_API_BASE_URL = 'https://azdemo.api.cloudintelligence.industrycloud.pwc.com';

const AiAssistPage = () => (
  <div className={classes.wrap} data-testid="ai-assist-page">
    <div className={classes.platform}>
      <CipAiPlatformApp apiBaseUrl={CIP_AI_API_BASE_URL} authToken={accessToken.value} />
    </div>
  </div>
);

export default AiAssistPage;
